import React, { Component } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';

import './ProcessSettings.css';

class ProcessSettings extends Component {

    constructor(props) {
        super(props);

        this.state = {
            errMsg: ''
        };
    }

    onLoad = () => {
        //console.log("Modal is loaded");
    }

    render() {
        return (

            <Modal
              show={this.props.showProcessSettings}
              onHide={this.props.hideProcessSettings}
              onEntered={this.onLoad}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 className="pageTitle">Process Settings</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                <Form className="ProcessSettingsForm">
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmProcessName">
                            <Form.Label className="ProcessLabel">Process</Form.Label>
                            <Form.Control className="ProcessSettingsName" type="text" value={this.props.process.Name} readOnly plaintext/>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="frmHiddenParam">
                            <Form.Label className="ProcessLabel">Default Parameters</Form.Label>
                            <Form.Control as="textarea" rows={4} className="ProcessSettingsParam" placeholder="param1;param2;param3" value={this.props.process.HiddenParam || ''} onChange={this.props.handleUpdateHiddenParam}/>
                            <Form.Text className="text-muted">
                                Semicolon-separated parameters passed to this process when it runs over a recording.
                            </Form.Text>
                        </Form.Group>
                    </Form.Row>

                </Form>
            </div>
            </Modal.Body>

            <Modal.Footer>
                <span className="ProcessSettingsErr">{this.state.errMsg}</span>
                <Button onClick={this.props.handleSaveProcessSettings}>Save</Button>
                <Button onClick={this.props.hideProcessSettings}>Close</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default ProcessSettings;
